import { ConfigError, ConfigType, IConfigManager } from '@cp/shared/config';

export class ConfigManager<C extends ConfigType = ConfigType> implements IConfigManager<C> {
  readonly #values: C;
  constructor(values: C) {
    this.#values = values;
  }

  has<T extends keyof C | string>(key: T): boolean {
    return this.#values.hasOwnProperty(key);
  }

  get<T extends keyof C>(key: T): T extends keyof C ? C[T] | null : null;
  get<T extends keyof C, V extends T extends keyof C ? C[T] : unknown>(key: T, def: V): T extends keyof C ? C[T] : V;

  get<T extends keyof C | string, V = T extends keyof C ? NonNullable<C[T]> : never>(key: T, def?: V) {
    return this.has(key) ? this.#values[key as keyof C] : def || null;
  }

  getOrThrow<T extends keyof C | string, R extends T extends keyof C ? C[T] : never>(key: T): R {
    if (this.#values.hasOwnProperty(key)) {
      return this.#values[key as keyof C] as R;
    }
    throw ConfigError.NotFound(key);
  }
}
